import React from 'react';
import MerchantSetting from './MerchantSetting';

export default function Tab() {
    return <MerchantSetting />;
}
